import { defineNuxtPlugin } from "#app";
import axios from "axios";
import { useUserStore } from "~/stores/userstore";

export default defineNuxtPlugin((_unusedNuxtApp) => {
  console.debug("axios-override.client.ts loaded");
  console.debug("axios-override.client.ts" + process.env.API_BASE_URL);
  console.info("axios-override.client.ts" + axios);

  const userStore = useUserStore();

  // Create a custom axios instance
  const customAxios = axios.create({
    baseURL: process.env.API_BASE_URL || "",
    timeout: 240000, // 4 minutes timeout - is that enough?
  });

  // Add random delay between 300ms and 2500ms before every request is sent for testing
  /*  customAxios.interceptors.request.use(
    async (config) => {
      const delay = Math.floor(Math.random() * (2500 - 300 + 1)) + 300;
      await new Promise<void>((resolve) => setTimeout(resolve, delay));
      return config;
    },
    (error) => Promise.reject(error),
  );*/

  // interceptors to check for 401
  customAxios.interceptors.response.use(
    (res) => res,
    async (error) => {
      if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") {
        console.error("API request timed out");

        // Fake a StoreApiError so the existing errorMessage Handler can be used
        error.response = {
          ...error.response,
          status: 408,
          data: {
            status: 408,
            errorId: "TIMEOUT",
            errors: [
              "The server did not respond in time. Please try again later.",
            ],
          },
        };

        return Promise.reject(error);
      }

      const code = error.response?.status;
      console.debug("response code ", code);
      if (code === 401) {
        console.warn("Logout due to 401");
        await userStore.logout();
        error.response.loggedOut = true; // set flag so we can modify the user message to -> your session has expired
        return Promise.reject(error);
      }
      return Promise.reject(error);
    },
  );

  // Override the default axios exports
  Object.assign(axios, customAxios);
});
